import { IconBell, IconBellOff, IconBellRinging, IconMenu2 } from '@tabler/icons-react';

import { useBarObrashcheniy } from '../features/obrashcheniya/hooks';
import { usePodpiskaNaPush } from './push';

const ADRES_PANELI = 'https://admin.opsmind.ru';

/**
 * ШАПКА ЛАЙТА — название, колокольчик, переход в панель (`s608`, решение владельца).
 *
 * ⛔ ЗНАЧОК, А НЕ ВЫДВИЖНОЙ ЯЩИК (владелец, 18.09). Разделов у лайта нет вовсе:
 * ящик с меню означал бы, что половина панели сюда всё-таки переехала.
 *
 * ⛔ СЧЁТЧИК — ИЗ ТОГО ЖЕ ИСТОЧНИКА, ЧТО СПИСОК. Число берётся общим запросом
 * сводки (`useBarObrashcheniy`) — тем же, которым живёт шапка панели. Посчитай
 * его здесь по строкам списка — и два числа на одном экране разошлись бы на
 * такт, ровно как это уже было у панели (`s605`).
 */
export function ShapkaLayta() {
  const bar = useBarObrashcheniy(true);
  const push = usePodpiskaNaPush();

  const zhdut = bar.data?.ne_prochitano ?? bar.data?.novyh ?? 0;

  return (
    <header className="flex shrink-0 items-center gap-2 border-b border-ops-border bg-ops-surface px-3 py-2">
      <span className="flex-1 truncate text-ops-title font-semibold text-ops-text">Переписка</span>

      <button
        type="button"
        onClick={() => void push.pereklyuchit()}
        disabled={push.zanyat || !push.dostupno}
        title={push.podpis}
        aria-label={push.podpis}
        className="relative shrink-0 rounded-ops-pill p-1.5 text-ops-text-secondary hover:bg-ops-surface-2 hover:text-ops-primary disabled:opacity-40"
      >
        {!push.dostupno ? (
          <IconBellOff size={22} />
        ) : push.podpisan ? (
          <IconBellRinging size={22} />
        ) : (
          <IconBell size={22} />
        )}
        {zhdut > 0 && (
          /*
            ⛔ Число, а не точка: «есть непрочитанное» и «непрочитанных
            четырнадцать» — разные новости для человека, который решает,
            открывать ли телефон прямо сейчас.
          */
          <span className="absolute -right-0.5 -top-0.5 min-w-[18px] rounded-ops-pill bg-ops-danger px-1 text-center text-ops-micro font-semibold leading-[18px] text-white">
            {zhdut > 99 ? '99+' : zhdut}
          </span>
        )}
      </button>

      {/*
        ⛔ ОБЫЧНАЯ ССЫЛКА, А НЕ ПЕРЕХОД ВНУТРИ ПРИЛОЖЕНИЯ. Панель — другое
        приложение на другом адресе; вход общий (кука выписана на всю систему),
        поэтому второй раз пароль не спросят.
      */}
      {/*
        ⛔⛔ ПАНЕЛЬ ОТКРЫВАЕТСЯ ОТДЕЛЬНЫМ ОКНОМ (владелец, 18.09, `s615`).
        Без `target` переход съедал само окно лайта: человек, поставивший
        значок на главный экран, нажимал гамбургер — и приложение «Переписка»
        превращалось в панель, вернуться из которой можно было только закрыв
        и открыв значок заново. `rel="noopener"` обязателен к `_blank`: без
        него открытая вкладка получает ссылку на окно лайта через
        `window.opener`.
      */}
      <a
        href={ADRES_PANELI}
        target="_blank"
        rel="noopener noreferrer"
        title="Открыть панель"
        aria-label="Открыть панель"
        className="shrink-0 rounded-ops-pill p-1.5 text-ops-text-secondary hover:bg-ops-surface-2 hover:text-ops-primary"
      >
        <IconMenu2 size={22} />
      </a>
    </header>
  );
}
